const ITEMS = [
  "Identidade Visual",
  "Logotipos",
  "Kits para Instagram",
  "Artes sob encomenda",
  "Essenza Studio",
];

export default function Marquee() {
  const strip = (ariaHidden) => (
    <div aria-hidden={ariaHidden || undefined} className="flex shrink-0 items-center">
      {ITEMS.map((item, i) => (
        <span key={`${item}-${i}`} className="flex items-center">
          <span className={`px-8 font-display text-2xl font-extrabold uppercase tracking-tight sm:text-4xl ${i % 2 ? "text-outline" : "text-ink"}`}>
            {item}
          </span>
          <span className="h-2 w-2 rounded-full bg-accent" aria-hidden="true" />
        </span>
      ))}
    </div>
  );

  return (
    <section className="overflow-hidden border-y border-line py-6 sm:py-8" data-testid="marquee-section">
      <div className="marquee-track">
        {strip(false)}
        {strip(true)}
      </div>
    </section>
  );
}
